var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchedSocketOutlet01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.12,
    y: 1.28,
    className: "st2",
    width: 0.5,
    height: 13.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.51,12.99l-0.04-0.5c2.5-0.19,4.36-2.31,4.22-4.82C7.51,5.41,5.65,3.61,3.37,3.49l0.03-0.5 c2.53,0.13,4.59,2.13,4.8,4.65C8.34,10.43,6.29,12.78,3.51,12.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.02,
    y: 7.75,
    className: "st2",
    width: 4.61,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "11.63,12.26 11.14,12.13 11.53,10.55 7.73,9.7 7.83,9.22 12.14,10.17  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchedSocketOutlet01);
export default __webpack_public_path__ + "static/media/SwitchedSocketOutlet-01.e99a0f138a13c0771afeb00919621751.svg";
export { ForwardRef as ReactComponent };